import { useContext } from 'react'
import { TableContext } from 'contexts/TableContext'

export const useTable = () => {
  return useContext(TableContext)
}
